module.exports = __webpack_public_path__ + "img/sort-down.d49abd60.svg";